<template>
	<div>
		<el-card class="page-container">
			<el-row class="title-biaoti">通用运营位操作</el-row>

			<el-row>
				<el-tabs v-model="activeName">
					<el-tab-pane label="用户通用运营位" name="first"
						><Tab1></Tab1
					></el-tab-pane>
					<el-tab-pane label="主播banner位" name="second"
						><Tab2></Tab2
					></el-tab-pane>
				</el-tabs>
			</el-row>
		</el-card>
	</div>
</template>
<script>
import Tab2 from './banner'
import Tab1 from './generate_operating'
export default {
	components: { Tab1, Tab2 },
	data() {
		return {
			activeName: 'first',
		}
	},
	methods: {},
}
</script>
<style lang="scss" scoped>
</style>
